import { Injectable } from '@angular/core';
import { CommonHttpService } from './http.service';
import { Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class EbitService {
    private configurationLoadedSource: Subject<null> = new Subject();

    protected ebitStoreId: number = null;

    public configurationLoaded$ = this.configurationLoadedSource.asObservable();

    constructor (
        protected http: CommonHttpService
    ) {
        if (null === this.ebitStoreId) {
            this.loadEbitStoreId();
        }
    }

    public loadEbitStoreId() {
        this.http
            .get('/_data?scope=store-configurations')
            .subscribe((response: Response) => {
                const configurations = response.json().data['store-configurations'];

                if (
                    configurations['ebit-storeId'] !== undefined
                    && configurations['ebit-storeId'] !== null
                ) {
                    this.ebitStoreId = configurations['ebit-storeId'];
                    return this.configurationLoadedSource.next(null);
                }
                return this.configurationLoadedSource.next(null);
            });
    }

    public getEbitStoreId(): number {
        return this.ebitStoreId;
    }
    public buildEbitSurveyHref(): string {
        return `https://newsurvey.ebit.com.br/Survey/Open/${+this.ebitStoreId}`
            + `?&utm_source=checkoutloja&utm_medium=bannerverdelojas`
            + `&utm_campaign=respondapesquisa`;
    }
    public buildEbitBannerSrc(): string {
        return `https://www.ebitempresa.com.br/bitrate/banners/banner_320.gif`
            + `?storeId=${+this.ebitStoreId}`;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/services/ebit.service.ts